import React from 'react';
import { ReorderUserRule } from '../types/reorderUserRule';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface ReorderUserRuleContextProps {
  reorderUserRules: Map<string, ReorderUserRule>;
  setReorderUserRules: (reorderUserRules: Map<string, ReorderUserRule>) => void;
  groupedReorderUserRules: Map<string, ReorderUserRule[]>;
  reorderUserRulesLoading: boolean;
}

const defaultContext: ReorderUserRuleContextProps = {
  reorderUserRules: new Map(),
  setReorderUserRules: () => {},
  reorderUserRulesLoading: false,
  groupedReorderUserRules: new Map<string, ReorderUserRule[]>(),
};

export const ReorderUserRuleContext = React.createContext<ReorderUserRuleContextProps>(defaultContext);

interface ReorderUserRuleState {
  items: Record<string, any>[];
  loading: boolean;
}

export const reorderUserRuleSlice = createSlice({
  name: 'reorderUserRule',
  initialState: { items: [], loading: true } as ReorderUserRuleState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<ReorderUserRule[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<ReorderUserRule[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
